const initialState = {
    allBatches: [],
    performance: {},
    myPerformance: {}
}

const batchReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_BATCHES':
            return { ...state, allBatches: action.data }
        case 'GET_BATCH':
            return { ...state, batch: action.data }
        case 'GET_BATCH_PERFORMANCE':
            return {
                ...state,
                performance: {
                    ...(state.performance || {}),
                    [action.batchId]: action.data
                }
            }
        case 'GET_MY_PERFORMANCE':
            return {
                ...state,
                myPerformance: {
                    ...(state.myPerformance || {}),
                    [action.batchId]: action.data
                }
            }
        case 'GET_ALL_USERS':
            return {
                ...state,
                allUsers: action.data,
                userTotal: action.total
            }
        default:
            return state
    }
}

export default batchReducer
